export const hasError = state => state.auth.signIn.hasError
export const isPending = state => state.auth.signIn.isPending
export const user = state => state.auth.user
